import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {
  ChargerClaim,
  ChargerClaimRequest,
  ClaimOtpVerifyRequest,
} from './charger-claim.interface';

/**
 * Repair Dispatch: charger ownership claims.
 * Two-step: submit a claim (server emails a one-time code), then verify it.
 * A matching email domain auto-verifies; otherwise it drops to manual review.
 */
@Injectable({
  providedIn: 'root',
})
export class ClaimService {
  constructor(private http: HttpClient) {}

  /** Create a claim. The server emails a one-time code to contactEmail. */
  submitClaim(data: ChargerClaimRequest) {
    return this.http.post<ChargerClaim>(
      `${environment.api.repair}/claim`,
      data,
    );
  }

  /** Resend the one-time code for an existing (AWAITING_OTP) claim. */
  resendOtp(claimId: string) {
    return this.http.post<void>(`${environment.api.repair}/claim/otp`, {
      claimId,
    });
  }

  /** Confirm the code. May auto-verify when the email domain matches. */
  verifyOtp(data: ClaimOtpVerifyRequest) {
    return this.http.post<ChargerClaim>(
      `${environment.api.repair}/claim/otp/verify`,
      data,
    );
  }
}
